// `AccountDeletedPage` — landing after a successful account deletion (US-014).
//
// Per `apps/api/src/auth/index.ts:databaseHooks.user.beforeDelete`, the
// API cancels the Stripe sub, archives LinkedIn accounts, and lets the
// FK cascade clear domain rows before BA wipes the user. The web client
// then drops the session and redirects here. The page is intentionally
// terminal — no auto-refresh / no shell — just a polite confirmation +
// link back to home.

import { Link } from '@tanstack/react-router';

import { useT } from '@barel/i18n';
import { Button } from '@barel/ui';

import { AuthLayout } from './AuthLayout';

export function AccountDeletedPage() {
  const t = useT('auth');
  return (
    <AuthLayout brandHeadline="brandHeadlineNeutral">
      <section
        data-route="auth/account-deleted"
        className="flex flex-col items-center gap-4 text-center"
      >
        <h1 className="text-2xl font-semibold text-primary">{t('accountDeleted.title')}</h1>
        <p className="max-w-md text-sm text-secondary">{t('accountDeleted.body')}</p>
        <Link to="/auth/login" data-testid="account-deleted-home">
          <Button variant="primary" size="md">
            {t('accountDeleted.homeCta')}
          </Button>
        </Link>
      </section>
    </AuthLayout>
  );
}
